import React from 'react'
import { components } from 'react-select'
import * as Styles from './styles'
import _ from 'lodash'
import { useIntl } from 'react-intl'

const normalizeString = str => {
  const lower = _.lowerCase(str)
  return _.deburr(lower)
}

const ValueContainer = ({ children, ...props }) => {
  const selectValue = props.selectProps.value
  const menuIsOpen = props.selectProps.menuIsOpen
  const { formatMessage } = useIntl()
  return (
    <components.ValueContainer {...props}>
      {selectValue && !menuIsOpen ? (
        <>
          <Styles.SelectedValue>
            <p>{selectValue.label?.name}</p>
            <span>
              {' '}
              {selectValue.label.address ||
                formatMessage({ id: 'Street Not Informed' })}
              ,{' '}
              {selectValue.label.area ||
                formatMessage({ id: 'Neighborhood Not Informed' })}{' '}
              -{' '}
              {selectValue.label.city ||
                formatMessage({ id: 'City Not Informed' })}{' '}
              /{' '}
              {selectValue.label.state ||
                formatMessage({ id: 'State Not Informed' })}
            </span>
          </Styles.SelectedValue>
        </>
      ) : (
        children
      )}
    </components.ValueContainer>
  )
}

function Option({
  label,
  value,
  cx: _cx,
  hasValue,
  setValue,
  selectProps,
  ...props
}) {
  const { formatMessage } = useIntl()
  const handleClick = () => {
    if (hasValue) {
      if (selectProps.value?.value === value) {
        setValue(null)
        return
      }
    }
    setValue({ value, label })
  }

  return (
    <Styles.OptionContainer
      onClick={handleClick}
      {...props}
      data-active={selectProps.value?.value === value}
    >
      <span className="title">{label.name}</span>
      <span className="description">
        {label.address || formatMessage({ id: 'Street Not Informed' })},{' '}
        {label.area || formatMessage({ id: 'Neighborhood Not Informed' })} -{' '}
        {label.city || formatMessage({ id: 'City Not Informed' })} /{' '}
        {label.state || formatMessage({ id: 'State Not Informed' })}
      </span>
    </Styles.OptionContainer>
  )
}
function Select({
  placeholder,
  value,
  onChange,
  uniqueKey,
  options,
  ...props
}) {
  const filterOption = (option, inputValue) => {
    const validName = option.label.name
      .toLowerCase()
      .includes(normalizeString(inputValue.toLowerCase()))

    const validAddress = option.label.address
      .toLowerCase()
      .includes(normalizeString(inputValue.toLowerCase()))

    const validSublocality = option.label.city
      .toLowerCase()
      .includes(normalizeString(inputValue.toLowerCase()))
    const validLocality = option.label.state
      .toLowerCase()
      .includes(normalizeString(inputValue.toLowerCase()))

    return validName || validAddress || validSublocality || validLocality
  }

  return (
    <Styles.Container>
      <Styles.CustomSelect
        key={uniqueKey}
        options={options}
        placeholder={placeholder}
        classNamePrefix="react-select"
        menuPortalTarget={document.querySelector('body')}
        isSearchable
        isClearable={false}
        onChange={newValue => {
          onChange(newValue)
        }}
        closeMenuOnSelect={true}
        blurInputOnSelect={false}
        hideSelectedOptions={false}
        filterOption={filterOption}
        controlShouldRenderValue={false}
        isLoading={props.loading || false}
        value={value}
        styles={{
          SelectContainer: base => ({
            ...base,
            padding: '16px',
            backgroundColor: 'red',
          }),
        }}
        {...props}
        components={{
          Option,
          ValueContainer: p => <ValueContainer {...p} />,
        }}
      />
    </Styles.Container>
  )
}

export default Select
